import React, { useState } from 'react';
import { ImageIcon } from '@saleshandy/design-system';
import Transfer from '../../design-system/components/transfer';
import './overlay-merge-tags.scss';
import { MergeTagOption } from './types';
import { TransferOverlayTriggerProps } from '../../design-system/components/transfer/transfer-overlay-trigger';
import { Images } from '../../app-constants';

type OverlayMergeTagsProps = Pick<
  TransferOverlayTriggerProps<MergeTagOption>,
  'options' | 'placement' | 'children' | 'searchPlaceholder' | 'className'
> & {
  onChange: (option: MergeTagOption) => void;
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
  // eslint-disable-next-line react/require-default-props
  onSearch?: (value: string) => void;
  // eslint-disable-next-line react/require-default-props
  onToggle?: (show: boolean) => void;
  // eslint-disable-next-line react/require-default-props
  showAiGeneratedIcon?: boolean;
};

const OverlayMergeTags = ({
  options,
  onChange,
  placement,
  children,
  searchPlaceholder,
  className,
  disabled = false,
  onSearch,
  onToggle,
  showAiGeneratedIcon = false,
}: OverlayMergeTagsProps) => {
  const [show, setShow] = useState(false);
  return (
    <Transfer<MergeTagOption>
      options={options}
      optionFilterProp="label"
      optionRenderer={(option) => (
        <span className="overlay-merge-tags__option">
          <span>{option.label}</span>
          {showAiGeneratedIcon && option.isAiGenerated && (
            <ImageIcon src={Images.NoResultGradient} alt="ai-generated" width={16} height={16} />
          )}
        </span>
      )}
      onChange={([option]) => {
        onChange(option);
        setShow(false);
      }}
      show={show}
      onToggle={(value) => {
        if (!disabled) {
          setShow(value);
          onToggle?.(value);
        }
      }}
      placement={placement}
      searchPlaceholder={searchPlaceholder}
      autoFocusSearch={true}
      className={className}
      onSearch={onSearch}
    >
      {children}
    </Transfer>
  );
};

export default OverlayMergeTags;
